import request from "../utils/request";

let baseUrl;
let adminApi;
function resolveApiPrefix(rawValue, fallback) {
  const value = (rawValue || "").toString().trim();
  if (!value || value === "undefined" || value === "null") {
    return fallback;
  }
  return value;
}

baseUrl = resolveApiPrefix(process.env.VUE_APP_BASE_URL, "/baseUrl");
adminApi = resolveApiPrefix(process.env.VUE_APP_ADMIN_API, "/adminApi");

export const Login = (p) => {
  return request({
    url: baseUrl + "/system/auth/loginSingle",
    method: "post",
    data: p,
  });
};

// 鐧诲嚭
export const loginOut = () => {
  return request({
    url: baseUrl + "/system/auth/logout",
    method: "post",
  });
};

/**
 * 甯冭崏鍒嗙被缁熻
 */
export const getBigSkuCategory = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuCategory",
    method: "get",
    params: p,
  });
};

/**
 * 甯冭崏鏀跺彂骞达紝鏈堬紝鏃ョ粺璁? */
export const getBigSkuCount = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuCount",
    method: "get",
    params: p,
  });
};

/**
 * 甯冭崏鎶ュ簾鎺掑悕
 */
export const getBigSkuDispose = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuDispose",
    method: "get",
    params: p,
  });
};

/**
 * 鎶ュ簾缁囩墿鎺掑悕鏁版嵁缁熻锛堟柊鎺ュ彛锛? */
export const getBigSkuDisposeNew = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuDisposeNew",
    method: "get",
    params: p,
  });
};

/**
 * 甯冭崏娲楁钉娆℃暟鎺掑悕
 */
export const getBigSkuWashSpu = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuWashSpu",
    method: "get",
    params: p,
  });
};

/**
 * 瀹炴椂鐩戞帶
 */
export const getBigSkuDivision = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuDivision",
    method: "get",
    params: p,
  });
};

/**
 *
 * // 搴撳瓨棰勮
 */

export const getSpuStockWarning = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSpuStockWarning`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 浠婃棩鎶ュ簾锛岀櫥璁帮紝鍑哄簱锛岃姱鐗囨洿鎹㈡暟閲? */

export const getSkuCountToday = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSkuCountToday`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 缁熻涓€骞存礂娑ら噺瓒嬪娍
 */

export const getBigSkuWashMonth = (p) => {
  return request({
    url: baseUrl + `/rent/big/getBigSkuWashMonth`,
    method: "get",
    params: p,
  });
};
export const getNewBigSkuWashMonth = (p) => {
  return request({
    url: baseUrl + `/rent/big/getNewBigSkuWashMonth`,
    method: "get",
    params: p,
  });
};
/**
 *
 * 缁囩墿娲楁钉娆℃暟鍒嗘瀽
 */

export const getBigSkuWashCategoryTime = (p) => {
  return request({
    url: baseUrl + `/rent/big/getBigSkuWashCategoryTime`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 缁囩墿娲楁钉娆℃暟鍒嗘瀽(鏂版帴鍙?
 */

export const getBigSkuWashCategory = (p) => {
  return request({
    url: baseUrl + `/rent/big/getBigSkuWashCategory`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 缁囩墿娲楁钉娆℃暟鍒嗘瀽鍒嗙被绠＄悊
 * 缂撳瓨鎺ュ彛
 */

export const getCategoryPage = () => {
  const cacheKey = "category_page_data";
  const cachedData = localStorage.getItem(cacheKey);
  console.log("cachedDatacachedDatacachedData", cachedData);
  if (cachedData) {
    try {
      const parsedData = JSON.parse(cachedData);
      return Promise.resolve({
        data: parsedData,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
      });
    } catch (error) {
      console.error("解析缓存数据失败:", error);
      localStorage.removeItem(cacheKey);
    }
  }

  return request({
    url: baseUrl + "/rent/public/selectCategory",
    method: "get",
  }).then((response) => {
    console.log(response);
    try {
      localStorage.setItem(cacheKey, JSON.stringify(response.data));
    } catch (error) {
      console.error("写入缓存失败:", error);
    }
    return response;
  });
};
/**
 *
 * 鑾峰彇鍖婚櫌
 */
export const selectCustomer = (p) => {
  const cacheKey = "customer_data";
  const cachedData = localStorage.getItem(cacheKey);
  console.log("customer_data", cachedData);
  if (cachedData) {
    try {
      const parsedData = JSON.parse(cachedData);
      return Promise.resolve({
        data: parsedData,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
      });
    } catch (error) {
      console.error("解析缓存数据失败:", error);
      localStorage.removeItem(cacheKey);
    }
  }

  return request({
    url: baseUrl + "/rent/public/selectCustomer",
    method: "get",
    params: p,
  }).then((response) => {
    console.log(response);
    try {
      localStorage.setItem(cacheKey, JSON.stringify(response.data));
    } catch (error) {
      console.error("写入缓存失败:", error);
    }
    return response;
  });
};

/**
 *
 * 鑾峰彇鍖婚櫌
 */
export const getSkuCount = (p) => {
  return request({
    url: adminApi + `/rent/report/getSkuCount`,
    method: "post",
    data: p,
  });
};

/**
 *
 * 甯冭崏鎸夊尰闄㈠垎缁勭粺璁? */
export const getBigSkuCustomer = (p) => {
  return request({
    url: baseUrl + `/rent/big/getBigSkuCustomer`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 甯冭崏鎸夊尰闄㈣繘琛屾暟閲忕粺璁? */
export const getOrderSkuCustomer = (p) => {
  return request({
    url: baseUrl + `/rent/big/getOrderSkuCustomer`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 甯冭崏鎶ュ簾鏁伴噺鎸夊尰闄㈠垎缁勭粺璁? */
export const getBigSkuDisposeCustomer = (p) => {
  return request({
    url: baseUrl + `/rent/big/getBigSkuDisposeCustomer`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 甯冭崏鎶ュ簾鏁伴噺鎸夊尰闄㈠垎缁勭粺璁? */
export const getBigSkuDisposeCategory = (p) => {
  return request({
    url: baseUrl + `/rent/big/getBigSkuDisposeCategory`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 甯冭崏婊炵暀鏁伴噺鎸夊尰闄㈠垎缁勭粺璁? */
export const getSkuPreLossCustomer = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSkuPreLossCustomer`,
    method: "get",
    params: p,
  });
};
/**
 *
 * 甯冭崏婊炵暀鏁伴噺鎸夊尰闄㈠垎缁勭粺璁? */
export const getSkuPreLossCategory = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSkuPreLossCategory`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 甯冭崏涓㈠け鏁伴噺鎸夊尰闄㈠垎缁勭粺璁? */
export const getSkuLossCustomer = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSkuLossCustomer`,
    method: "get",
    params: p,
  });
};
/**
 *
 * 甯冭崏涓㈠け鏁伴噺鎸夊尰闄㈠垎缁勭粺璁? */
export const getSkuLossCategory = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSkuLossCategory`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 鑾峰彇瀹㈡埛鍒楄〃
 */
export const getSkuCustomerList = (p) => {
  return request({
    url: baseUrl + `/rent/big/getSkuCustomerList`,
    method: "get",
    params: p,
  });
};

/**
 *
 * 鍒锋柊token
 */
export const refreshToken = (p) => {
  return request({
    url: baseUrl + `/system/auth/refresh-token`,
    method: "post",
    data: p,
  });
};

/**
 *
 * 鑾峰彇鏈嶅姟缁熻淇℃伅
 */
export const getServiceStatMessage = () => {
  return request({
    url: baseUrl + `/rent/big/getServiceStatMessage`,
    method: "get",
  });
};

/**
 * 娲楁钉鍘傚疄鏃舵暟鎹粺璁? */
export const getBigServiceProvider = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigServiceProvider",
    method: "get",
    params: p,
  });
};

/**
 * 鍖婚櫌缁囩墿娴侀€氬疄鏃舵暟鎹粺璁★紙鏂版帴鍙ｏ級
 */
export const getBigSkuCustomerNew = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuCustomerNew",
    method: "get",
    params: p,
  });
};

/**
 * 骞存湀鏃ユ礂娑ゆ暟鍜岄厤閫佹暟缁熻
 */
export const getSpuWashCountYmd = (p) => {
  return request({
    url: baseUrl + "/rent/big/getSpuWashCountYmd",
    method: "get",
    params: p,
  });
};

/**
 * 鍖婚櫌娲楁钉鏁扮粺璁★紙鎸夋棩鏈?鏈堜唤锛? */
export const getBigSkuCustomerCash = (p) => {
  return request({
    url: baseUrl + "/rent/big/getBigSkuCustomerCash",
    method: "get",
    params: p,
  });
};

